export default __webpack_public_path__ + "media/images/logo_white_navy-b394dbfa322cffced83d8df1fe6a838e.png";